/**
 * Launch Dashboard Page
 * Main page for launch preparation and go-live execution
 */

import React from 'react';
import LaunchDashboard from '../../components/launch/LaunchDashboard';

const LaunchDashboardPage = () => {
  return (
    <div>
      <LaunchDashboard />
    </div>
  );
};

export default LaunchDashboardPage;
